
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 47.4 131.2"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"23.7","cy":"27","r":"10"}}),_c('path',{attrs:{"d":"M11.3 73.8l-.7 51c0 3.3 2.7 6 6 6s6-2.7 6-6v-41h2.3v40.8c0 3.3 2.7 6 6 6s6-2.7 6-6l-.7-51H11.3v.2z"}}),_c('path',{attrs:{"d":"M46.7 61.5c-.6-5.8-1.8-12-5.1-16.9-1.2-1.7-2.7-3.2-3.9-4.2-.9-.8-2.1-1.2-3.3-1.2H13.1c-1.2 0-2.4.4-3.3 1.2-1.2 1-2.7 2.5-3.9 4.2C2.6 49.5 1.4 55.7.8 61.5.1 69 .6 76.4 2.5 83.8c.4 1.5 1.7 2.5 3.2 2.5.4 0 .9-.1 1.3-.3 1.5-.6 2.3-2.4 1.9-4-1-4.2-1.6-8.3-1.7-12.5-.1-2.4-.1-4 .3-7.3.4-3.6 1.4-8.8 3.8-14.9 0-.1.1 0 .1 0V71.6H36.1V47.3s.1-.1.1 0c2.4 6.1 3.4 11.3 3.8 14.9.4 3.3.4 4.9.3 7.3-.1 4.2-.7 8.3-1.7 12.5-.4 1.6.4 3.4 1.9 4 .4.2.9.3 1.3.3 1.5 0 2.8-1 3.2-2.5 1.9-7.4 2.4-14.8 1.7-22.3z"}}),_c('g',{attrs:{"fill":"#FFF"}},[_c('path',{attrs:{"d":"M15.7 56.7v-7.1h1.9v7.1h-1.9zM22.3 51c-.5 0-.8.2-1.1.6s-.4.9-.4 1.6c0 1.4.5 2.1 1.6 2.1.3 0 .6 0 .9-.1l.9-.3v1.6c-.6.3-1.3.4-2 .4-1.1 0-1.9-.3-2.5-.9-.6-.6-.9-1.5-.9-2.7 0-.7.1-1.4.4-1.9.3-.6.7-1 1.2-1.3s1.1-.5 1.8-.5c.8 0 1.5.2 2.2.5l-.4 1.4c-.3-.1-.5-.2-.8-.3s-.6-.2-.9-.2zM31.8 56.7h-1.9v-2.9h-2.2v2.9h-1.9v-7.1h1.9v2.6h2.2v-2.6h1.9v7.1z"}})])])
          )
        }
      }
    